import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import { NFTType } from '@webapp/pages/catalog/nft-tab';
import { formatNumber } from '@webapp/pages/earnings';

interface NFTDesktopInfoRowProps {
  item: NFTType;
}

const NFTDesktopInfoRow: FunctionComponent<NFTDesktopInfoRowProps> = ({
  item,
}) => {
  return (
    <Wrapper>
      <Flex
        className="quantity"
        justifyContent="space-between"
        alignItems="center"
        gap={10}
      >
        <Typography type="small">{formatNumber(item.qty)}</Typography>
      </Flex>

      <div className="third-column">
        <Typography type="small">{item.owenership}</Typography>
      </div>
      <div className="fourth-column">
        <Typography type="small">{item.stakeholders}</Typography>
      </div>
    </Wrapper>
  );
};

export default NFTDesktopInfoRow;

const Wrapper = styled.div`
  display: grid;
  grid-gap: 24px;
  grid-template-columns: repeat(18, minmax(0, 1fr));

  .avatar {
    grid-column: 1 / 2;
  }

  .quantity {
    grid-column: 2 / 8;
  }

  .third-column {
    grid-column: 8 / 11;
  }

  .fourth-column {
    grid-column: 11 / 15;
  }
`;

export const SongNumber = styled(Flex)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.primary};

  .number {
    color: ${({ theme }) => theme.colors.differentBackground};
  }

  &.nft {
    background-color: ${({ theme }) => theme.colors.secondary};

    .number {
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;
